// src/main.ts
//
// Made with ❤️ by Maysara.



// ╔════════════════════════════════════════ PACK ════════════════════════════════════════╗

    import { cli }  from './core/builder';

    export * from './core';
    export * from './core/builder';
    export * from './core/types.d';

    export default cli;

// ╚══════════════════════════════════════════════════════════════════════════════════════╝